import script from "./BookingHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingHome.vue?vue&type=script&setup=true&lang=js"

import "./BookingHome.vue?vue&type=style&index=0&id=ace5b5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace5b5f2"]])

export default __exports__